import * as React from 'react';
import {Input} from 'antd';
import {useState} from "react";


//TODO: use InputProps and send mode in this options


interface SearchInputProps {
    placeholder?: string;
    search: (filter:object)=>any;
}

/**
 * This is a simple search input which handle search on Enter
 * @param props
 * @constructor
 */
const SearchInput:React.FC<SearchInputProps> = props => {
    const {placeholder=`جستجو`, search} = props;
    const [inputVal, setInputVal] = useState("");


    const onChange = (event) => {
        const val = event.target.value;
        setInputVal(val);
    };

    return(
        <Input value={inputVal}
               placeholder={placeholder}
               onChange={ event => onChange(event)}
               onPressEnter={() => search({
                   query : inputVal
               })}/>
    )

};

export default SearchInput